import { Box, Tab, TabList, Tabs, Text } from '@chakra-ui/react';
import { TexasDrawerHeader } from '@texas/components/shared/drawer/TexasDrawerHeader';
import { TexasDrawerSubHeader } from '@texas/components/shared/drawer/TexasDrawerSubHeader';
import {
  Scrollable,
  ScrollableContainer,
} from '@texas/components/shared/scrollable/Scrollable';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AllSuppliers } from './AllSuppliers';
import { RecommendedSuppliers } from './RecommendedSuppliers';
import { VariantBranchSupplier } from '@texas/api/endpoints/variantsApi';
import { SimpleNote } from '@texas/components/shared/SimpleNote';

export function AddSupplier({
  branchId,
  branchName,
  branchIdentifier,
  variantId,
  isPdVariant,
  onAdd,
  setIsAddingToBranch,
}: {
  branchId: number;
  branchName: string;
  branchIdentifier?: string;
  variantId: number;
  isPdVariant: boolean;
  onAdd?: (data: VariantBranchSupplier) => void;
  setIsAddingToBranch?: (id: number | null) => void;
}) {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState<number>(0);

  if (!isPdVariant) {
    return (
      <ConnectSupplier
        branchId={branchId}
        branchName={branchName}
        branchIdentifier={branchIdentifier}
        variantId={variantId}
        onAdd={onAdd}
        setIsAddingToBranch={setIsAddingToBranch}
      />
    );
  }

  return (
    <ScrollableContainer>
      <TexasDrawerHeader
        title={t('suppliers.addSupplier')}
        subTitle={branchName}
      />
      <Tabs onChange={(index) => setTabIndex(index)}>
        <TexasDrawerSubHeader style={{ padding: 0, paddingX: 0 }}>
          <TabList>
            <Tab>{t('general.recommended')}</Tab>
            <Tab>{t('suppliers.all')}</Tab>
          </TabList>
        </TexasDrawerSubHeader>
      </Tabs>
      {tabIndex === 0 && (
        <Scrollable>
          <RecommendedSuppliers
            onAdd={onAdd}
            variantId={variantId}
            branchId={branchId}
            branchName={branchName}
            branchIdentifier={branchIdentifier}
            setIsAddingToBranch={setIsAddingToBranch}
          />
        </Scrollable>
      )}
      {tabIndex === 1 && (
        <Scrollable>
          <AllSuppliers
            onAdd={onAdd}
            variantId={variantId}
            branchId={branchId}
            branchName={branchName}
            branchIdentifier={branchIdentifier}
            isPdVariant={false}
            setIsAddingToBranch={setIsAddingToBranch}
          />
        </Scrollable>
      )}
    </ScrollableContainer>
  );
}

function ConnectSupplier({
  branchId,
  branchName,
  branchIdentifier,
  variantId,
  onAdd,
  setIsAddingToBranch,
}: {
  branchId: number;
  branchName: string;
  branchIdentifier?: string;
  variantId: number;
  onAdd?: (data: VariantBranchSupplier) => void;
  setIsAddingToBranch?: (id: number | null) => void;
}) {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <TexasDrawerHeader
        title={t('suppliers.connectSupplier')}
        subTitle={branchName}
      />
      <Box
        m={4}
        p={2}
        color="yellow.200"
        backgroundColor="whiteAlpha.100"
        borderRadius="md"
        _light={{
          backgroundColor: 'blackAlpha.100',
          color: 'orange.500',
        }}
      >
        <SimpleNote>
          <Text fontSize="sm" whiteSpace="pre-line">
            {t('suppliers.managedOnPd')}
          </Text>
        </SimpleNote>
      </Box>
      <Scrollable>
        <AllSuppliers
          onAdd={onAdd}
          variantId={variantId}
          branchId={branchId}
          branchName={branchName}
          branchIdentifier={branchIdentifier}
          isPdVariant={true}
          setIsAddingToBranch={setIsAddingToBranch}
        />
      </Scrollable>
    </ScrollableContainer>
  );
}
